import styled from "styled-components";
import { apolloSpaceInline5X, apolloSpaceInset1HalfX, apolloSpaceInset1X, apolloSpaceStack5X, apolloZindexDialog, apolloZindexDialogOverlay, } from "@nexthink/apollo-tokens";
import { BARE_BUTTON_ICON_SIZE, StyledButtonIcon } from "../button-icon/ButtonIcon.style";
import Flex from "../box/Flex";
const borderRadius = 4;
export const StyledModalOverlay = styled.div.withConfig({ displayName: "StyledModalOverlay_APC-7311-productShell", componentId: "sc-qfennu" })(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors.apolloColorBackgroundDialogOverlay,
    position: "fixed",
    inset: 0,
    zIndex: apolloZindexDialogOverlay,
}));
export const StyledModalDialog = styled.div.withConfig({ displayName: "StyledModalDialog_APC-7311-productShell", componentId: "sc-wct4zw" })(({ theme, width, height, variant }) => (Object.assign({ display: "flex", overflow: "visible", position: "relative", backgroundColor: theme.colors.apolloColorBackgroundContainer, border: `1px solid ${theme.colors.apolloColorStrokeDialog}`, borderRadius, padding: "0", zIndex: apolloZindexDialog, inset: 0, outline: "none !important" }, (variant === "media"
    ? {
        maxHeight: `calc(100vh - ${apolloSpaceStack5X} * 2)`,
        maxWidth: `calc(100vw - ${apolloSpaceInline5X} * 2)`,
        boxShadow: theme.colors.apolloBoxShadowDialog,
    }
    : {
        maxHeight: "80vh",
        width,
        height,
    }))));
export const StyledCloseButtonContainer = styled(Flex).withConfig({ displayName: "StyledCloseButtonContainer_APC-7311-productShell", componentId: "sc-13qqkvu" })(({ theme, variant }) => (Object.assign({ position: "absolute", cursor: "pointer", zIndex: apolloZindexDialog }, (variant === "media"
    ? {
        top: `-${apolloSpaceInset1X}`,
        right: `-${apolloSpaceInset1X}`,
        borderRadius: "50%",
        background: theme.colors.apolloColorBackgroundDialog,
        boxShadow: theme.colors.apolloBoxShadowDialog,
        [`${StyledButtonIcon}`]: {
            width: 32,
            height: 32,
            borderRadius: "50%",
        },
        [`&:hover ${StyledButtonIcon}`]: {
            borderColor: theme.colors.apolloColorStrokeButtonHover,
        },
    }
    : {
        top: `${apolloSpaceInset1HalfX}`,
        right: `${apolloSpaceInset1HalfX}`,
        width: BARE_BUTTON_ICON_SIZE,
        height: BARE_BUTTON_ICON_SIZE,
    }))));
//# sourceMappingURL=Modal.style.js.map